<template>
  <w-icon-wrapper
    :height="22"
    :width="22"
    icon-name="work-checkbox-minus-icon"
    view-box="0 0 22 22"
  >
    <g
      id="Gruppe_25446"
      data-name="Gruppe 25446"
    >
      <path
        id="Pfad_55797"
        data-name="Pfad 55797"
        d="M19,2a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2Zm0-2H3A3,3,0,0,0,0,3V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3"
        fill="currentColor"
      />
      <path
        id="Pfad_55798"
        data-name="Pfad 55798"
        d="M15.5,9.781h-9a.92.92,0,1,0,0,1.833h9a.92.92,0,1,0,0-1.833"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckboxMinus' };
</script>
